/**
 * AuthButton — the gradient primary button used across every auth form.
 *
 * `busy` renders an inline spinner AND disables the button, so a
 * mid-flight submit cannot be re-triggered. `disabled` is the caller-
 * managed variant (e.g. form invalid). Both semantics collapse into
 * the underlying HTMLButtonElement's disabled state.
 */

import React from 'react';

function AuthButton({
  children,
  busy = false,
  disabled = false,
  type = 'submit',
  variant = 'primary',
  ...rest
}) {
  const className = variant === 'secondary'
    ? 'auth-button auth-button-secondary'
    : 'auth-button';
  return (
    <button
      type={type}
      className={className}
      disabled={busy || disabled}
      aria-busy={busy || undefined}
      {...rest}
    >
      {busy && <span className="auth-button-spinner" aria-hidden="true" />}
      <span>{children}</span>
    </button>
  );
}

export default AuthButton;
